import Copyright from '../components/Copyright';
import React, { useState, useEffect } from 'react';
import { logsAPI } from '../utils/api';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export default function HistoryPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();
  const limit = 20;

  useEffect(() => {
    setLoading(true);
    logsAPI.getLogs(page, limit)
      .then(res => { setLogs(res.data.logs); setTotal(res.data.total); })
      .catch(() => toast.error('Failed to load history'))
      .finally(() => setLoading(false));
  }, [page]);

  const deleteLog = async (id, date) => {
    if (!window.confirm(`Delete log for ${date}?`)) return;
    try {
      await logsAPI.deleteLog(id);
      setLogs(p => p.filter(l => l.id !== id));
      toast.success('Log deleted');
    } catch { toast.error('Failed to delete'); }
  };

  const viewLog = (log) => navigate(`/today?date=${cleanDate(log.log_date)}`);

  const formatDate = (dateStr) => {
    // Strip time component if present, then parse as local date
    const datePart = dateStr.split('T')[0];
    const [year, month, day] = datePart.split('-').map(Number);
    const d = new Date(year, month - 1, day);
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
  };

  const cleanDate = (dateStr) => dateStr.split('T')[0];

  const totalPages = Math.ceil(total / limit);

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">HISTORY</h1>
          <p style={{ color: 'var(--text-2)', fontSize: 14 }}>{total} logs total</p>
        </div>
      </div>

      <div className="page-body">
        {loading ? (
          <div className="loading-center"><div className="spinner" /></div>
        ) : logs.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">📋</div>
            <div className="empty-state-title">No logs yet</div>
            <div className="empty-state-sub">Start logging on the Today page</div>
          </div>
        ) : (
          <>
            <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
              <table className="table">
                <thead>
                  <tr>
                    <th>Date</th><th>Weight</th><th>BMI</th>
                    <th>Calories</th><th>Protein</th><th>Sleep</th>
                    <th>Exercises</th><th>Day Rating</th><th></th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map(log => {
                    const ratings = [log.rating_morning, log.rating_afternoon, log.rating_evening].filter(Boolean);
                    const avgRating = ratings.length ? (ratings.reduce((a,b) => a+b, 0) / ratings.length).toFixed(1) : null;
                    return (
                      <tr key={log.id} style={{ cursor: 'pointer' }} onClick={() => viewLog(log)}>
                        <td style={{ fontWeight: 600 }}>
                          <div>{formatDate(log.log_date)}</div>
                          <div style={{ fontSize: 11, color: 'var(--text-3)', fontFamily: 'var(--font-mono)' }}>{cleanDate(log.log_date)}</div>
                        </td>
                        <td>{log.weight ? `${log.weight}` : '—'}</td>
                        <td>{log.bmi ? parseFloat(log.bmi).toFixed(1) : '—'}</td>
                        <td>{log.caloric_intake ? `${log.caloric_intake} kcal` : '—'}</td>
                        <td>{log.protein_g ? `${Math.round(log.protein_g)}g` : '—'}</td>
                        <td>{log.hours_sleep ? `${log.hours_sleep}h` : '—'}</td>
                        <td>
                          {log.exercises?.length > 0
                            ? <span className="badge badge-red">💪 {log.exercises.length}</span>
                            : '—'}
                        </td>
                        <td>
                          {avgRating
                            ? <span className="badge badge-amber">⭐ {avgRating}/5</span>
                            : '—'}
                        </td>
                        <td onClick={e => e.stopPropagation()}>
                          <div style={{ display: 'flex', gap: 6 }}>
                            <button className="btn btn-secondary btn-sm"
                              onClick={() => viewLog(log)}>✏️ Edit</button>
                            <button className="btn btn-danger btn-sm"
                              onClick={() => deleteLog(log.id, cleanDate(log.log_date))}>✕</button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 20 }}>
                <button className="btn btn-secondary btn-sm" onClick={() => setPage(p => Math.max(1, p-1))}
                  disabled={page === 1}>← Prev</button>
                <span style={{ padding: '6px 12px', fontSize: 14, color: 'var(--text-2)' }}>
                  {page} / {totalPages}
                </span>
                <button className="btn btn-secondary btn-sm" onClick={() => setPage(p => Math.min(totalPages, p+1))}
                  disabled={page === totalPages}>Next →</button>
              </div>
            )}
          </>
        )}
      </div>
    <Copyright />
    </div>
  );
}
